import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { withFormik, FormikProps } from 'formik';
import { Grid, Box, CircularProgress, MenuItem } from '@material-ui/core';
import { translate } from 'helpers/intl';
import validationSchema from 'components/ReportABugModal/validationSchema';
import messages from 'components/ReportABugModal/messages';
import { OrangeButton } from 'components/Button';
import { ColoredDivider, StyledGrid } from 'components/MenuItem/styles';
import { ShortBody } from 'components/Typography';
import { StyledForm } from 'components/ChangePassewordModal/styles';
import get from 'lodash/get';
import SelectInputField from 'components/SelectInputField';
import InputField from 'components/InputField';

const ChangePasswordForm = (
  props: {
    handleClose: Function;
    isLoading: boolean;
  } & FormikProps<FormValues>,
) => {
  const BugTypes = [
    {
      value: '0',
      label: translate(get(messages, 'reportGeneral'), props),
    },
    {
      value: '1',
      label: translate(get(messages, 'reportConexion'), props),
    },
    {
      value: '2',
      label: translate(get(messages, 'reportAUTO'), props),
    },
    {
      value: '4',
      label: translate(get(messages, 'reportMRH'), props),
    },
    {
      value: '6',
      label: translate(get(messages, 'reportQR'), props),
    },
    {
      value: '7',
      label: translate(get(messages, 'reportNotif'), props),
    },
    {
      value: '8',
      label: translate(get(messages, 'epargn'), props),
    },
  ];
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
  } = props;
  return (
    <StyledForm onSubmit={handleSubmit}>
      <Box paddingX={2} pb={2}>
        <Grid container justify="center">
          <Grid item xs={12}>
            <Box mb={3}>
              <ShortBody weight="400">
                {translate(get(messages, 'report_title'), props)}
              </ShortBody>
              <SelectInputField
                name="object"
                label={translate(get(messages, 'object'), props)}
                onChange={handleChange}
                value={values.object}
                data={BugTypes}
                handleBlur={handleBlur}
                Children={[...BugTypes].map((item: any) => (
                  <MenuItem value={item.value} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <InputField
              name="message"
              multiline
              rows={4}
              placeholder={translate(get(messages, 'message'), props)}
              value={values.message}
              error={errors.message && touched.message}
              helperText={touched.message && errors.message}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
          </Grid>
        </Grid>
      </Box>
      <ColoredDivider orientation="horizontal" />
      <StyledGrid spacing={5} container justify="flex-end">
        <Grid item>
          <OrangeButton onClick={props.handleClose}>
            {translate(get(messages, 'cancel'), props)}
          </OrangeButton>
        </Grid>
        <Grid item>
          <OrangeButton
            type="submit"
            variant="contained"
            disabled={props.isLoading}
          >
            {translate(get(messages, 'send'), props)}
            {props.isLoading ? (
              <CircularProgress
                color="inherit"
                size={20}
                style={{ marginLeft: '5px' }}
              />
            ) : null}
          </OrangeButton>
        </Grid>
      </StyledGrid>
    </StyledForm>
  );
};

export interface FormProps {
  intl: IntlShape;
  reportABug: Function;
  handleClose: Function;
  isLoading: boolean;
}

interface FormValues {
  object: string;
  message: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      object: '0',
      message: '',
    };
  },
  validationSchema,
  handleSubmit: (values, { props }) => {
    const dataToSend = {
      message: values.message,
      idBug: values.object,
    };
    props.reportABug(dataToSend);
    return props.handleClose();
  },
})(ChangePasswordForm);

export default injectIntl(Form);
